import { useEffect, useState, useRef } from 'react'
import { useTranslation } from "react-i18next";
import { Adjustments } from 'components/misc/Icons'

const LanguageMenu = () => {

    const node = useRef();
    const [t, i18n] = useTranslation('common');
    const [languagesOpen, setLanguagesOpen] = useState(false)

    const handleClickOutside = e => {
        if (node.current.contains(e.target)) {
            // inside click
            return;
        }
        setLanguagesOpen(false);
    };

    useEffect(() => {
        if (languagesOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [languagesOpen]);

    return (
        <div
            ref={node}
            onClick={e => setLanguagesOpen(!languagesOpen)}
            className="relative flex items-center justify-center w-6 h-6 cursor-pointer focus:outline-none text-textlight dark:text-textdark">
            <Adjustments width="6" height="6" stroke="1"/>
            {languagesOpen && (
            <div className="absolute w-48 py-2 mt-48 mr-40 overflow-hidden border rounded z-1100 bg-itemlight dark:bg-itemdark border-borderlight dark:border-borderdark">
                <button
                    onClick={() => i18n.changeLanguage('id')}
                    className="flex items-center w-full px-2 py-3 transition-colors duration-200 transform hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-textlight dark:text-textdark">
                    <span className="ml-2 text-sm font-light">Bahasa Indonesia</span>
                </button>
                <button
                    onClick={() => i18n.changeLanguage('de')}
                    className="flex items-center w-full px-2 py-3 transition-colors duration-200 transform hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-textlight dark:text-textdark">
                    <span className="ml-2 text-sm font-light">Deutsch</span>
                </button>
                <button
                    onClick={() => i18n.changeLanguage('en')}
                    className="flex items-center w-full px-2 py-3 transition-colors duration-200 transform hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-textlight dark:text-textdark">
                    <span className="ml-2 text-sm font-light">English (UK)</span>
                </button>
            </div>
            )}
        </div>
    )
}

export default LanguageMenu
